import React, {useEffect} from "react";

const SmiWidget = ({isFull, isDesktop, blockIds, visibleWidgets}) => {
    if (!blockIds) {
        return null;
    }

    const selectedIds = isFull ? (isDesktop ? blockIds.fullPc : blockIds.fullMob) : (isDesktop ? blockIds.prevPc : blockIds.prevMob);

    if (!selectedIds) {
        return null;
    }

    const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
    const visibleIds = visibleWidgets ? ids.slice(0, visibleWidgets) : ids;

    useEffect(() => {
        visibleIds.forEach(() => {
            (window.smiq = window.smiq || []).push({});
        });
    }, [visibleIds.length]);

    return (
        <React.Fragment>
            {visibleIds.map((id, index) => (
                <div key={index} className="smi24__informer smi24__auto" data-smi-blockid={id}></div>
            ))}
        </React.Fragment>
    );
};

export default SmiWidget;
